<script setup lang="ts">
import {
  useRecipeBackupStore,
  useRouterStore,
  useStatsigEventsStore,
} from '@apps/main/new-desktop/core/stores';

import { AppFlicker } from '@libs/ui';

import type { ItineraryAccommodationUpsellLoaderSegment } from '../../../../models';
import { useTripOverviewPageStore } from '../../../../stores';

import AccommodationUpsellSegmentLayout from './AccommodationUpsellSegmentLayout.vue';

interface AccommodationUpsellSegmentProps {
  segment: ItineraryAccommodationUpsellLoaderSegment;
}

const props = defineProps<AccommodationUpsellSegmentProps>();

const routerStore = useRouterStore();
const tripOverviewPageStore = useTripOverviewPageStore();
const recipeBackupStore = useRecipeBackupStore();
const statsigEventsStore = useStatsigEventsStore();

function navigateToHotelSelection(): void {
  const navigationIndex = { ingredientIndex: 1 };
  recipeBackupStore.createBackup();
  tripOverviewPageStore.addAccommodationToOwnStayIngredient(
    props.segment.context.ingredientId
  );
  routerStore.navigateToHotelSelection(navigationIndex);
  statsigEventsStore.logTripOverviewAccommodationUpsellHotelSelectionNavigation();
}
</script>

<template>
  <AccommodationUpsellSegmentLayout
    :segment="segment"
    @navigate-to-hotel-selection="navigateToHotelSelection"
  >
    <template #upsell-card>
      <div class="accommodaion-upsell-card-loader">
        <AppFlicker width="spacing-96" height="spacing-16" />
        <AppFlicker width="spacing-64" height="spacing-16" />
      </div>
    </template>
  </AccommodationUpsellSegmentLayout>
</template>

<style scoped lang="scss">
.accommodaion-upsell-card-loader {
  width: 343px;
  max-width: calc(100vw - 3 * var(--spacing-16));
  height: 392px;

  padding: var(--spacing-12);
  border-radius: var(--border-radius-12);
  background-color: var(--color-white);

  display: flex;
  flex-direction: column;
  gap: var(--spacing-8);
  margin-right: var(--spacing-12);
}
</style>
